import { render, staticRenderFns } from "./RegAsDistToNuFinalForm.vue?vue&type=template&id=25263d04&scoped=true&"
import script from "./RegAsDistToNuFinalForm.vue?vue&type=script&lang=js&"
export * from "./RegAsDistToNuFinalForm.vue?vue&type=script&lang=js&"
import style0 from "./RegAsDistToNuFinalForm.vue?vue&type=style&index=0&id=25263d04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25263d04",
  null
  
)

export default component.exports